function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "avatar-tanaka-2x-a",
  width: 95,
  height: 95,
  rx: 22
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "avatar-tanaka-2x-b",
  x1: "50%",
  y1: "0%",
  x2: "50%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#89CAEC",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3F7AB5",
  offset: "60.065%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1D7ABB",
  offset: "100%"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "avatar-tanaka-2x-c",
  fill: "#FFF"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#avatar-tanaka-2x-a"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#FFF",
  xlinkHref: "#avatar-tanaka-2x-a"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#avatar-tanaka-2x-b)",
  mask: "url(#avatar-tanaka-2x-c)",
  d: "M70.886 6.5H24.114C14.4 6.5 6.5 14.4 6.5 24.114v46.772C6.5 80.6 14.4 88.5 24.114 88.5h46.772C80.6 88.5 88.5 80.6 88.5 70.886V24.114C88.5 14.4 80.6 6.5 70.886 6.5zm5.928 61.72c0 4.865-3.94 8.806-8.805 8.806H21.53c-1.934 0-3.502-1.568-3.502-3.503V23.62c0-1.936 1.568-3.504 3.503-3.504h51.78c1.94 0 3.51 1.568 3.51 3.503v44.6zM42.302 31.585v10.553c0 .988-.802 1.79-1.79 1.79h-10.7c-.99 0-1.79-.802-1.79-1.79V31.584c0-.99.8-1.792 1.79-1.792H40.51c.99 0 1.792.802 1.792 1.792zm24.517 0v10.553c0 .988-.81 1.79-1.8 1.79H54.33c-.988 0-1.79-.802-1.79-1.79V31.584c0-.99.802-1.792 1.79-1.792h10.7c.99 0 1.79.802 1.79 1.792zM42.3 55.005V65.56c0 .988-.802 1.79-1.79 1.79H29.813c-.99 0-1.79-.802-1.79-1.79V55.005c0-.99.8-1.79 1.79-1.79H40.51c.99 0 1.792.8 1.792 1.79zm24.517 0V65.56c0 .988-.803 1.79-1.792 1.79H54.33c-.988 0-1.79-.802-1.79-1.79V55.005c0-.99.802-1.79 1.79-1.79h10.7c.99 0 1.79.8 1.79 1.79z"
}));

var SvgTanakaDark = function SvgTanakaDark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 95,
    viewBox: "0 0 95 95",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTanakaDark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tanaka-dark.23c85b88.svg";
export { ForwardRef as ReactComponent };